import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '../../../../../../node_modules/@angular/router';
import { ShoppingCartService } from '../../../../services/shopping-cart.service';
import { Subscription } from '../../../../../../node_modules/rxjs';
import { ShoppingCart } from '../../../../models/shopping-cart.model';
import { ApiResponse } from '../../../../models/api-response.model';
import { CommonService } from '../../../../services/common.service';
import { FileService } from '../../../../services/file.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../reducers';
import { getShoppingCartLoaded, getShoppingCarts, getSelectedShoppingCart } from '../../../../reducers/shoppingcart.reducer';
import { LoadShoppingCart } from '../../../../actions/shoppingcart.actions';
import { NgProgressService } from '../../../../services/ngProgress.service';

@Component({
    selector: 'app-upload-to-cart',
    templateUrl: './upload-to-cart.component.html',
    styleUrls: ['./upload-to-cart.component.css']
})
export class UploadToCartComponent implements OnInit {
    setFullWindow = false;
    title = 'Upload Stock Codes';
    comparedValue = 'text';
    selectedCart: number;
    selectedCartName: string;
    cartId: number;
    cartName: string;
    subscription: Subscription;
    subscriptionCartIdService: Subscription;
    shoppingCarts: ShoppingCart[] = [];
    stockCodes: string;
    file: any;
    formData = new FormData();
    loadContent = false;
    @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();


    constructor(
        private router: Router,
        private ngProgress: NgProgressService,
        private shoppingCartService: ShoppingCartService,
        private commonService: CommonService,
        private fileService: FileService,
        private store: Store<AppState>,
        private activatedRoute: ActivatedRoute,
        public activeModal: NgbActiveModal
    ) { }

    ngOnInit() {

        // this.shoppingCartService.currentCartId.subscribe(cn => {
        //     this.cartId = cn;
        // },
        //     (error: any) => {
        //         console.error(error);
        //     });

        // this.shoppingCartService.getCartName(this.cartId.toString()).subscribe(result => {
        //     this.cartName = result;
        // },
        //     (error: any) => {
        //         console.error(error);
        //     });
        this.store.select(getShoppingCartLoaded).subscribe((isLoaded) => {

            if (isLoaded) {

                this.loadContent = true;
                this.store.select(getSelectedShoppingCart).subscribe(cart => {
                    if (cart) {
                        this.cartId = cart.cartId;
                        this.cartName = cart.cartName;
                    }

                });

                this.store.select(getShoppingCarts).subscribe(sc => {
                    this.shoppingCarts = sc;
                    this.selectedCart = this.cartId ? this.cartId : this.shoppingCarts[0].cartId;
                    this.selectedCartName = this.cartName ? this.cartName : this.shoppingCarts[0].cartName;
                });
            }
        });

        // this.shoppingCartService.getShoppingCart().subscribe(sc => {
        //     this.shoppingCarts = sc;
        //     this.selectedCart = this.cartId ? this.cartId : this.shoppingCarts[0].cartId;
        //     this.selectedCartName = this.cartName ? this.cartName : this.shoppingCarts[0].cartName;
        // },
        //     (error: any) => {
        //         console.error(error);
        //     });
    }

    changeCart(val: string): void {
        this.shoppingCartService.monitorCartId(this.commonService.toNumber(val));
        this.shoppingCartService.monitorCartIdChange(this.commonService.toNumber(val));
        this.commonService.savecookies('CartId', val, 7);
        this.shoppingCartService
            .currentCartId
            .subscribe(cn => {
                this.cartId = cn;
            },
                (error: any) => { console.error(error); });
    }

    uploadText(): void {
        this.notify.emit(false);
        this.loadContent = false;
        // replace the new line with comma then replace the tab with space
        const strStockCodes = this.stockCodes.replace(/\n/g, ',').replace(/\s+/g, ' ').trim();
        const encodedStockCodes = encodeURIComponent(strStockCodes);
        this.shoppingCartService
            .uploadStockCodesText(this.shoppingCarts.filter(x => x.cartId === this.cartId)[0].cartId.toString(), encodedStockCodes)
            .subscribe((res: ApiResponse) => {
                if (res.status) {
                    this.shoppingCartService.monitorStatusChange(2);
                    this.store.dispatch(new LoadShoppingCart());
                    this.commonService.showSuccess('#btnUploadText', res.responseMessage, 'right');
                    setTimeout(() => {
                        this.notify.emit(true);
                    }, 1500);

                } else {
                    this.commonService.showError('#btnUploadText', res.responseMessage, 'right');

                }
            },
                (error: any) => {
                    console.error(error);
                    this.commonService.showError('#btnUploadText', error.responseMessage, 'right');
                });
    }

    clearText(): void {
        this.stockCodes = '';
    }

    onSelectFile(event): void {
        this.notify.emit(false);
        this.loadContent = false;
        this.file = event.target.files[0];
        this.formData.append(this.file.name, this.file);
        this.shoppingCartService
            .importExcelToCart(this.shoppingCarts.filter(x => x.cartId === this.cartId)[0].cartId.toString(), this.formData)
            .subscribe((res: ApiResponse) => {
                if (res.status) {
                    this.commonService.showSuccess('#btnUploadExcel', res.responseMessage, 'right');
                    setTimeout(() => {
                        this.notify.emit(true);
                    }, 1000);

                } else {
                    this.commonService.showError('#btnUploadExcel', res.responseMessage, 'right');

                }
            },
                (error: any) => {
                    console.error(error);
                    this.commonService.showError('#btnUploadExcel', error.responseMessage, 'right');

                });
    }

    downloadSampleFile(): void {
        this.ngProgress.start();
        this.fileService.saveFile('Sample-StockCodes.xlsx').subscribe(res => {
            this.fileService.saveAsExcelFile(res, 'Sample-StockCodes.xlsx');
            this.ngProgress.done();
        },
            (error: any) => {
                console.error(error);
                this.ngProgress.done();
            });

    }

    checkRadioButton(comparedValue: string) {
        this.comparedValue = comparedValue;
    }

    onLoading(currentLoadingStatus: boolean) {
        this.loadContent = !currentLoadingStatus;
    }

    close() {
        this.ngProgress.done();
        this.router.navigateByUrl('/myCarts/cart/' + this.cartId + '/' + this.cartName);
    }
}
